// LOCAL PRODUCTION CANDIDATE ONLY. Does not install or globally control app pixels.
(() => {
  'use strict';
  const banner = document.querySelector('[data-cookie-banner]');
  const dialog = document.querySelector('[data-cookie-dialog]');
  if (!banner || !dialog) return;
  function message(text) {
    banner.querySelector('[data-cookie-storage]').textContent = text;
    dialog.querySelector('[data-cookie-dialog-status]').textContent = text;
  }
  function contextAllowed() {
    if (window.top !== window) return false;
    const loc=window.location, theme=window.Shopify?.theme;
    return loc.protocol==='https:' && ['brautwunsch.de','www.brautwunsch.de','brautwunsch.myshopify.com'].includes(loc.hostname) &&
      String(theme?.id)==='203562385672' && ['unpublished','main','live'].includes(theme?.role);
  }
  if (!contextAllowed() || window.MaisonConsent) {
    banner.hidden = false;
    message('Privacy-Initialisierung gesperrt: Test-Theme-Kontext oder vorhandenen Manager prüfen.');
    return;
  }
  const config = JSON.parse(document.querySelector('#maison-config').textContent);
  const key = 'maison-consent';
  const support=window.MaisonConsentSupport;
  if(!support||support.policyVersion!==config.consentVersion){banner.hidden=false;message('Datenschutzeinstellungen nicht verfügbar. Bitte erneut prüfen.');return;}
  const evidence=support.createEvidence(localStorage,()=>Date.now());
  let action='save-selection';
  const maxAge = config.consentMaxAgeDays * 86400000;
  const timeoutMs = 5000;
  let state = 'unknown', confirmed = null, requested = null, revision = 0;
  let active = false, uncertain = false, apiPromise = null, privacyApi = null;
  let savedAt = null, trigger = null;
  const choice = v => v && typeof v.statistics === 'boolean' && typeof v.marketing === 'boolean' && typeof v.preferences === 'boolean';
  const copy = v => v ? {statistics:v.statistics, marketing:v.marketing, preferences:v.preferences} : null;
  function readNative() {
    if (!contextAllowed()) return null;
    try {
      const c = privacyApi.currentVisitorConsent();
      const analytics = privacyApi.analyticsProcessingAllowed(), marketing = privacyApi.marketingAllowed(), preferences = privacyApi.preferencesProcessingAllowed();
      if (!['yes','no',''].includes(c.analytics) || !['yes','no',''].includes(c.marketing) || !['yes','no',''].includes(c.preferences) ||
          typeof analytics !== 'boolean' || typeof marketing !== 'boolean' || typeof preferences !== 'boolean') return null;
      return {statistics:c.analytics, marketing:c.marketing, analyticsAllowed:analytics, marketingAllowed:marketing, preferences:c.preferences, preferencesAllowed:preferences};
    } catch { return null; }
  }
  function matches(value, native) {
    return !!native && native.statistics === (value.statistics ? 'yes' : 'no') &&
      native.marketing === (value.marketing ? 'yes' : 'no') && native.preferences === (value.preferences ? 'yes' : 'no') &&
      // A denial is not confirmed while Shopify still permits that purpose.
      (value.statistics || native.analyticsAllowed === false) &&
      (value.marketing || native.marketingAllowed === false) &&
      (value.preferences || native.preferencesAllowed === false);
  }
  function allowed(category) {
    if (category === 'necessary') return true;
    if (!['statistics','marketing','preferences'].includes(category) || state !== 'confirmed' || !fresh(savedAt) || !confirmed?.[category]) return false;
    const native = readNative();
    return matches(confirmed,native) && (category === 'statistics' ? native.analyticsAllowed : category === 'marketing' ? native.marketingAllowed : native.preferencesAllowed);
  }
  function announce() {
    banner.dataset.consentState = state;
    banner.setAttribute('aria-busy', String(state === 'pending'));
    dialog.setAttribute('aria-busy', String(state === 'pending'));
    window.dispatchEvent(new CustomEvent('maison:consent', {detail:{necessary:true,
      statistics:allowed('statistics'),marketing:allowed('marketing'),preferences:allowed('preferences')}}));
  }
  function persist(next) {
    const record={schema:4,version:config.consentVersion,state:next,
      necessary:true,requested:copy(requested),confirmed:copy(confirmed),savedAt,
      updatedAt:Date.now(),policyHash:support.policyHash};
    const journal=()=>{if(requested)evidence.append({state:next,action,requested,confirmed:next==='confirmed'?confirmed:null});};
    // Record confirmation before exposing a grant; persist denial/pending barriers first.
    if(next==='confirmed'){journal();localStorage.setItem(key,JSON.stringify(record));}
    else {localStorage.setItem(key,JSON.stringify(record));journal();}
  }
  function fail(text, next='failed') {
    if (!contextAllowed()) { next='blocked'; text='Test-Theme-Kontext nicht mehr bestätigt. Keine neue Consent-Verarbeitung.'; }
    state=next;banner.hidden=false;
    try { if(contextAllowed())persist(next); } catch { /* An already stored pending barrier must never become a success. */ }
    message(text);announce();
  }
  function connectPrivacy() {
    if (!contextAllowed()) return Promise.reject(Error('THEME_CONTEXT_LOST'));
    const ready = api => api && ['currentVisitorConsent','setTrackingConsent','analyticsProcessingAllowed','marketingAllowed','preferencesProcessingAllowed'].every(k=>typeof api[k]==='function');
    if (ready(privacyApi)) return Promise.resolve(privacyApi);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve,reject) => {
      const deadline = Date.now() + timeoutMs;
      let done=false, poll=null, featureRequested=false;
      function finish(api, error) {
        if (done) return;
        done=true;clearTimeout(poll);
        if (api) { privacyApi=api;resolve(api); }
        else reject(Error(error));
      }
      function inspect() {
        if (done) return;
        if (!contextAllowed()) { finish(null,'THEME_CONTEXT_LOST');return; }
        const api=window.Shopify?.customerPrivacy;
        if (ready(api)) { finish(api);return; }
        if (Date.now() >= deadline) { finish(null,'PRIVACY_API_UNAVAILABLE');return; }
        if (!featureRequested && typeof window.Shopify?.loadFeatures==='function') {
          featureRequested=true;
          // Use the officially documented Customer Privacy feature version; CDN paths are not feature contracts.
          // Loader callbacks are not a proof that all API methods are ready.
          try { window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], () => {
            if (!done && ready(window.Shopify?.customerPrivacy)) finish(window.Shopify.customerPrivacy);
          }); } catch { /* Still await actual API readiness within the same deadline. */ }
        }
        if (!done) poll=setTimeout(inspect,50);
      }
      inspect();
    }).catch(error=>{apiPromise=null;throw error;});
    return apiPromise;
  }
  function send(value) {
    if (!contextAllowed()) return Promise.reject(Error('THEME_CONTEXT_LOST'));
    return new Promise((resolve,reject)=>{
      let done=false;
      const timer=setTimeout(()=>{
        if(done)return;done=true;uncertain=true;reject(Error('CONSENT_TIMEOUT'));
      },timeoutMs);
      try {
        privacyApi.setTrackingConsent({analytics:value.statistics,marketing:value.marketing,preferences:value.preferences}, error=>{
          if(done)return;done=true;clearTimeout(timer);
          // Documented callback is void. Unexpected payloads fail closed pending real API verification.
          if(error !== undefined && error !== null)reject(Error('CONSENT_CALLBACK_ERROR'));
          else if(!matches(value,readNative()))reject(Error('CONSENT_READBACK_MISMATCH'));
          else resolve();
        });
      } catch { if(!done){done=true;clearTimeout(timer);reject(Error('CONSENT_API_ERROR'));} }
    });
  }
  async function process() {
    if(active)return;
    active=true;
    try {
      await connectPrivacy();
      while(state==='pending') {
        const mine=revision, value=copy(requested);
        await send(value);
        if(mine!==revision)continue; // No stale grant; next explicit decision is sent serially.
        confirmed=value;savedAt=Date.now();
        // Only now may a confirmed record replace the durable pending barrier.
        persist('confirmed');state='confirmed';banner.hidden=true;message('');announce();
        if(dialog.open)dialog.close();
      }
    } catch {
      fail(uncertain ? 'Antwort unklar. Maison gibt keine optionalen Funktionen frei. Eine shopweite Sperre ist nicht bestätigt. Bitte neu laden und prüfen.' :
        'Shopify bestätigt die Auswahl oder die wirksame Ablehnung nicht. Maison gibt keine optionalen Funktionen frei; eine shopweite Sperre ist nicht bestätigt. Bitte erneut prüfen.');
    } finally { active=false; }
  }
  function save(statistics,marketing,preferences) {
    if (!contextAllowed()) { fail(''); return; }
    revision++;requested={statistics,marketing,preferences};state='pending';banner.hidden=false;
    message('Auswahl wird mit Shopify bestätigt …');announce();
    try { persist('pending'); }
    catch {
      if(!statistics&&!marketing&&!preferences){
        // Withdrawal must still reach Shopify if local evidence storage is unavailable.
        state='failed';announce();
        void connectPrivacy().then(()=>send({statistics:false,marketing:false,preferences:false}))
          .then(()=>fail('Ablehnung bei Shopify bestätigt. Lokaler Verlauf nicht speicherbar; bitte Browsereinstellungen prüfen.'))
          .catch(()=>fail('Ablehnung nicht vollständig bestätigt. Bitte erneut prüfen.'));return;
      }
      fail('Die Auswahl kann nicht sicher gespeichert werden. Keine neue Freigabe. Bitte Browsereinstellungen prüfen.');return;
    }
    if(uncertain){fail('Antwort weiterhin unklar. Vor einem weiteren Versuch bitte neu laden und prüfen.');return;}
    void process();
  }
  function showSettings(event) {
    trigger=event?.currentTarget || document.activeElement;
    const value=requested || (state==='confirmed'?confirmed:null);
    dialog.querySelector('[data-consent-statistics]').checked=value?.statistics===true;
    dialog.querySelector('[data-consent-marketing]').checked=value?.marketing===true;
    dialog.querySelector('[data-consent-preferences]').checked=value?.preferences===true;
    if(!dialog.open)dialog.showModal();
    dialog.querySelector('[data-consent-statistics]').focus();
  }
  function reconcile() {
    if(active || uncertain || state==='failed') {announce();return;}
    if(state==='confirmed' && !fresh(savedAt)){fail('Die Bestätigung ist abgelaufen. Bitte erneut entscheiden.','expired');return;}
    if(state==='confirmed' && !matches(confirmed,readNative())) {
      fail('Lokale und Shopify-Auswahl weichen ab. Bitte Einstellungen prüfen und erneut entscheiden.','conflict');
    } else announce();
  }
  banner.hidden=false;
  let stored=null;
  try {
    const raw=localStorage.getItem(key);
    if(raw) {
      stored=JSON.parse(raw);
      // A storage write failure cannot silently restore an old accepted record.
      localStorage.setItem(key,raw);
    }
  } catch { state='failed';message('Gespeicherte Auswahl nicht sicher verfügbar. Keine optionale Maison-Freigabe; shopweite Sperre nicht bestätigt.'); }
  const fresh=v=>Number.isFinite(v)&&v<=Date.now()&&Date.now()-v<maxAge;
  if(state!=='failed' && stored?.schema===4 && stored.necessary===true && stored.version===config.consentVersion && stored.policyHash===support.policyHash) {
    if(stored.state==='confirmed' && choice(stored.confirmed) && fresh(stored.savedAt)) {
      confirmed=copy(stored.confirmed);requested=copy(confirmed);savedAt=stored.savedAt;
    } else if(['pending','failed','conflict'].includes(stored.state)) {
      requested=choice(stored.requested)?copy(stored.requested):null;
      state='failed';message('Die vorherige Auswahl ist nicht bestätigt. Bitte erneut prüfen und bewusst speichern.');
    }
  }
  document.querySelectorAll('[data-cookie-settings]').forEach(b=>b.addEventListener('click',showSettings));
  document.querySelectorAll('[data-consent-all]').forEach(b=>b.addEventListener('click',()=>{action='accept-all';save(true,true,true);}));
  document.querySelectorAll('[data-consent-none]').forEach(b=>b.addEventListener('click',()=>{action=confirmed&&Object.values(confirmed).some(Boolean)?'withdraw':'reject-all';save(false,false,false);}));
  document.querySelector('[data-consent-save]').addEventListener('click',()=>{action='save-selection';save(dialog.querySelector('[data-consent-statistics]').checked,dialog.querySelector('[data-consent-marketing]').checked,dialog.querySelector('[data-consent-preferences]').checked);});
  document.querySelector('[data-cookie-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{if(trigger?.isConnected)trigger.focus();});
  document.addEventListener('visitorConsentCollected',reconcile);
  window.addEventListener('pageshow',reconcile);
  window.addEventListener('storage',event=>{
    if(event.key!==key && event.key!==null)return;
    revision++;
    // Never adopt an external grant silently; protect any currently in-flight request.
    state='conflict';banner.hidden=false;message('Auswahl in einem anderen Tab geändert. Bitte hier erneut prüfen.');announce();
  });
  window.MaisonConsent=Object.freeze({
    get:()=>state==='confirmed' && fresh(savedAt)?{necessary:true,...copy(confirmed),version:config.consentVersion,savedAt}:null,
    allows:allowed,status:()=>state,open:showSettings,
    snapshot:()=>({state,requested:copy(requested),confirmed:state==='confirmed' && fresh(savedAt)?copy(confirmed):null,
      processing:active,uncertain,scope:'THEME_ADAPTERS_ONLY'})
  });
  const ownedGate=support.createOwnedGate({allows:allowed});
  Object.defineProperty(window,'MaisonOptional',{value:ownedGate,writable:false,configurable:false});
  window.addEventListener('maison:consent',()=>ownedGate.reconcile());
  try{evidence.prune();}catch{fail('Lokaler Auswahlverlauf nicht verfügbar. Bitte erneut prüfen.');}
  document.querySelector('[data-consent-history]')?.addEventListener('click',()=>{
    const output=document.querySelector('[data-consent-history-output]');
    try{output.value=evidence.export();output.hidden=false;}catch{message('Lokaler Auswahlverlauf nicht verfügbar.');}
  });
  const bootRevision=revision;
  connectPrivacy().then(()=>{
    if(revision!==bootRevision)return;
    if(confirmed && state!=='failed') {
      if(matches(confirmed,readNative())){state='confirmed';banner.hidden=true;message('');}
      else fail('Gespeicherte und native Auswahl weichen ab. Bitte erneut entscheiden.','conflict');
    }
    if (!confirmed && state === 'unknown') {
      const native = readNative();
      if (native && ((native.statistics === '' && native.analyticsAllowed) ||
          (native.marketing === '' && native.marketingAllowed) ||
          (native.preferences === '' && native.preferencesAllowed))) {
        message('Noch keine Auswahl bestätigt. Shopify erlaubt mindestens einen optionalen Zweck ohne ausdrückliche Auswahl. Maison gibt nichts Optionales frei; eine shopweite Sperre ist nicht bestätigt.');
      }
    }
    announce();
  }).catch(()=>{if(revision===bootRevision)fail('Shopify-Datenschutzdienst nicht verfügbar. Keine optionale Maison-Freigabe; shopweite Sperre nicht bestätigt.');});
  announce();

// Keep the fixed contact control clear of consent and visible purchase controls.
const whatsapp=document.querySelector('[data-contact-control]');let layoutPending=false,contactPlaced=false;
function positionWhatsapp(){layoutPending=false;if(!whatsapp)return;const actual=whatsapp.getBoundingClientRect(),currentOffset=parseFloat(whatsapp.style.getPropertyValue('--maison-whatsapp-offset'))||20,baseTop=actual.top+currentOffset-20,baseBottom=actual.bottom+currentOffset-20;const viewportBottom=window.visualViewport?window.visualViewport.offsetTop+window.visualViewport.height:innerHeight;let offset=20;
 for(const target of document.querySelectorAll('[data-cookie-banner],.add-button,.cart-line-actions,[data-mobile-controls]')){if(target.hidden||!target.getClientRects().length)continue;const obstacle=target.getBoundingClientRect(),top=baseTop-(offset-20),bottom=baseBottom-(offset-20);if(obstacle.top<viewportBottom&&obstacle.bottom>0&&actual.right>obstacle.left-12&&actual.left<obstacle.right+12&&bottom>obstacle.top-12&&top<obstacle.bottom+12)offset=Math.max(offset,viewportBottom-obstacle.top+12);}
 if(currentOffset!==offset||!whatsapp.style.getPropertyValue('--maison-whatsapp-offset'))whatsapp.style.setProperty('--maison-whatsapp-offset',offset+'px');
}
let contactInitialized=false;const readyObserver=new MutationObserver(prepareContact);function prepareContact(){if(!whatsapp||contactInitialized||!['true','locked'].includes(document.documentElement.dataset.maisonReady))return;contactInitialized=true;readyObserver.disconnect();(document.fonts?.ready||Promise.resolve()).then(()=>requestAnimationFrame(()=>{contactPlaced=true;positionWhatsapp();whatsapp.dataset.contactReady='true';}));}readyObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-maison-ready']});prepareContact();
function scheduleLayout(){if(!contactPlaced)return;if(!layoutPending){layoutPending=true;requestAnimationFrame(positionWhatsapp);}}
new ResizeObserver(scheduleLayout).observe(banner);new MutationObserver(scheduleLayout).observe(banner,{attributes:true,attributeFilter:['hidden']});
window.addEventListener('scroll',scheduleLayout,{passive:true});window.addEventListener('resize',scheduleLayout);window.visualViewport?.addEventListener('resize',scheduleLayout);window.visualViewport?.addEventListener('scroll',scheduleLayout);scheduleLayout();
// Withdrawal has its own guarded integration.
})();
